var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h3',[_vm._v("Geosearch Critical Minerals")]),_c('h4',[_vm._v("Energy Reimagined | Risk Simplified")])])}]

export { render, staticRenderFns }